import { useDocumentTitle } from "hooks/useDocumentTitle";
import { FC } from "react";
import SectionGridFilterCard from "./SectionGridFilterCard";
import { useData } from "data/data-provider";
import BgGlassmorphism from "designs/DesignA/components/BgGlassmorphism/BgGlassmorphism";

export interface ListingCarPageProps {
  className?: string;
}

const ListingCarPage: FC<ListingCarPageProps> = ({ className = "" }) => {
  const { companyDetails } = useData();
  useDocumentTitle(companyDetails?.seo_title);
  return (
    <div
      className={`nc-ListingCarPage relative overflow-hidden ${className}`}
      data-nc-id="ListingCarPage"
    >
      <BgGlassmorphism />

      <div className="container relative">
        <SectionGridFilterCard className="mt-12 pb-24 lg:pb-28" />
      </div>
    </div>
  );
};

export default ListingCarPage;
